import { InputHTMLAttributes, forwardRef } from 'react';
import { Controller } from 'react-hook-form';
import { currencyFormat } from '../../../utils/src/currency/currencyFormat';
import { Input } from './Input';

interface InputProps extends InputHTMLAttributes<HTMLInputElement> {
  name: string;
  control: any;
}

const InputCurrency = forwardRef<HTMLInputElement, InputProps>((props) => {
  const { name, control, ...rest } = props; 

  return (
    <Controller
      name={name}
      control={control}
      render={({ field }) => (
        <Input
          {...field}
          {...rest}
          onChange={(e) => {
            const formattedValue = currencyFormat(e.target.value);
            field.onChange(formattedValue);
          }}
          placeholder="R$ 0,00"
        />
      )}
    />
  );
});

InputCurrency.displayName = 'InputCurrency';

export { InputCurrency };